define( 'jquery-private',[ 'jquery' ], function ( jq ) {
	'use strict';

	return jq.noConflict();
});
